import { LAW } from "../constants";
import { isKeikaDate, resolveColumns } from "./columns";
import { isBetween, isDateGte, normalizeValue } from "./utils";

export const KEIKA_COL = {
  OLD_NAME: "旧地域区分",
  NEW_NAME: "新地域区分",
  CODE: "地域区分コード",
  NAME: "地域区分",
  LAW: "法区分",
  KEIKA: "経過的措置",
  BEGIN_DATE: "適用開始年月日",
  END_DATE: "適用終了年月日",
};

export function isKeikasochi(law, date, keikasochi = false) {
  if (keikasochi && law === LAW.SHOUGAI) return true;
  return isKeikaDate(date) && (keikasochi || law === LAW.SHOUGAI);
}

function oldDate(law, date, keikasochi) {
  if (isDateGte(date, "2018-04-01") && law === LAW.SHOUGAI && keikasochi) return "2018-04-01";
  if (isDateGte(date, "2016-04-01") && law === LAW.SHOUGAI && keikasochi) return "2016-04-01";
  if (isDateGte(date, "2015-04-01") && law === LAW.SHOUGAI && keikasochi) return "2015-04-01";
  return "2006-10-01";
}

function newDate(date, keikasochi) {
  if (isKeikaDate(date) && keikasochi) return "2012-04-01";
  if (isDateGte(date, "2018-04-01")) return "2018-04-01";
  if (isDateGte(date, "2016-04-01")) return "2016-04-01";
  return "2015-04-01";
}

function oldNameColumn(law, date, keikasochi = false) {
  let oldLaw = law;
  if (keikasochi) {
    if (law === LAW.JIDOU) oldLaw = LAW.SHOUGAI;
    else if (law === LAW.SHOUGAI) oldLaw = LAW.JIDOU;
    else oldLaw = "";
  }
  return resolveColumns(oldLaw, date, false)[1];
}

function newNameColumn(law, date, keikasochi = false) {
  const newLaw = keikasochi ? LAW.JIDOU : law;
  return resolveColumns(newLaw, date, false)[1];
}

export function resolveKeikaName(chiikiRows, law, date, keikasochi, keikaRows) {
  if (!chiikiRows.length) return null;
  const first = chiikiRows[0];
  const oldCol = oldNameColumn(law, oldDate(law, date, keikasochi), keikasochi);
  const newCol = newNameColumn(law, newDate(date, keikasochi), keikasochi);
  const old = normalizeValue(first[oldCol]);
  const current = normalizeValue(first[newCol]);
  const matched = keikaRows.find(
    (row) =>
      normalizeValue(row[KEIKA_COL.LAW]) === normalizeValue(law) &&
      normalizeValue(row[KEIKA_COL.OLD_NAME]) === old &&
      normalizeValue(row[KEIKA_COL.NEW_NAME]) === current &&
      isBetween(date, row[KEIKA_COL.BEGIN_DATE], row[KEIKA_COL.END_DATE]),
  );
  return matched ? normalizeValue(matched[KEIKA_COL.NAME]) : null;
}
